import React, { FC } from 'react'
import { Button } from 'antd'
import { Modal } from 'antd-v4'
import { inject } from 'mobx-react'

interface IDeleteConfirmationModalProps {
  onClose: () => void
  name: string
  message: string
  onConfirm: () => void
  isDeleting: boolean
  isOpen: boolean
}

export const DeleteConfirmationModal: FC<IDeleteConfirmationModalProps> = inject()(
  ({ onClose, name, message, onConfirm, isDeleting, isOpen }: IDeleteConfirmationModalProps) => {
    return (
      <Modal
        visible={isOpen}
        onCancel={onClose}
        title={'Delete ' + name}
        footer={[
          <Button key='cancel' onClick={onClose}>
            Cancel
          </Button>,
          <Button key='save' type='danger' onClick={onConfirm} loading={isDeleting}>
            Yes
          </Button>,
        ]}
      >
        <div>
          <label>{message}</label>
        </div>
      </Modal>
    )
  },
)
